<template>
  <div class="text-black text-base overflow-hidden max-w-screen" :dir="localeStore.direction">
    <main class="container mx-auto px-4 md:px-8">
      <router-view></router-view>
    </main>
  </div>
</template>

<script setup>
import axios from 'axios'
import { useLocaleStore } from '@/stores/locale'

const localeStore = useLocaleStore()

axios.defaults.baseURL = import.meta.env.VITE_HOST + '/api'
axios.defaults.xsrfCookieName = 'csrftoken'
axios.defaults.xsrfHeaderName = 'X-CSRFToken'
axios.defaults.allowAbsoluteUrls = true
</script>

<script>
// Matomo
  const _paq = window._paq = window._paq || [];
  /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
  _paq.push(["setDoNotTrack", true]);
  _paq.push(['trackPageView']);
  _paq.push(['enableLinkTracking']);
  (function() {
    const u="https://matomo.wikimedia.fr/";
    _paq.push(['setTrackerUrl', u+'matomo.php']);
    _paq.push(['setSiteId', '13']);
    const d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
    g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
  })();
</script>
<style>
@import url('@wikimedia/codex/dist/codex.style.css');

header {
  display: flex;
  flex-direction: row;

  font-size: larger;
}

main {
  margin: auto;
  display: flex;
  flex-direction: column;
}
</style>
